import React from 'react';
import { useTypedTranslation } from '@app/hooks';
import { PasslyButton } from '@app/components';
import Icon from '@app/components/Icon/index';

interface IReceivedData {
    displayName: string;
    letsGetStartedCallback: Function;
}

const OnboardWelcomeComponent = (props: IReceivedData) => {
    const { translation } = useTypedTranslation();

    const getStarted = () => {
        props.letsGetStartedCallback();
    };

    return (
        <>
            <Icon icon='onboardingWelcomeIco' className='onboard__welcome-icon' />
            <h1 className='onboard__break-word'>
                {translation('ONBOARD_WELCOME_HI')} <strong>{props.displayName}</strong>
            </h1>
            <div className='onboard__description'>
                <div className='onboard__description-top'>
                    {translation('ONBOARD_WELCOME_DESCRIPTION1')}
                    <strong>{translation('ONBOARD_WELCOME_DESCRIPTION2')}</strong>
                    {translation('ONBOARD_WELCOME_DESCRIPTION3')}
                </div>
                <div>{translation('ONBOARD_WELCOME_DESCRIPTION4')}</div>
            </div>
            <div className='onboard__buttons'>
                <PasslyButton
                    type='submit'
                    variant='contained'
                    color='primary'
                    id='letsGetStartedButton'
                    className='onboard__button--submit'
                    onClick={getStarted}
                    disableRipple={true}
                >
                    {translation('ONBOARD_WELCOME_LETS_GET_STARTED')}
                </PasslyButton>
            </div>
        </>
    );
};

export default OnboardWelcomeComponent;
